<div class="px-4 py-8 max-w-4xl mx-auto">
  <button routerLink="/" class="text-primary-400 hover:text-white flex items-center gap-2 mb-8 transition-colors">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
      class="w-5 h-5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
    </svg>
    Back to Pools
  </button>

  @if (isLoading()) {
  <div class="flex justify-center py-20">
    <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-primary-500"></div>
  </div>
  }

  @if (!isLoading()) {
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
    <!-- STAKE ACTION CARD -->
    <div class="cardhover-animation glossy-card rounded-3xl p-8 shadow-2xl relative">
      <div class="absolute inset-0 rounded-3xl overflow-hidden pointer-events-none z-0">
        <div class="absolute top-0 right-0 w-64 h-64 bg-primary-500/5 rounded-full blur-3xl -mr-20 -mt-20">
        </div>
      </div>
      <h2 class="text-2xl font-bold mb-6 text-white relative z-10 font-groozila uppercase tracking-wider">Stake LOONY</h2>
      <div class="mb-6 relative z-10">
        <div class="flex justify-between text-sm text-gray-400 mb-2 font-medium">
          <span>Amount to Stake</span>
          <span>Balance: {{ userBalance() | number:'1.0-2' }}</span>
        </div>
        <div class="relative flex items-center">
          <input type="number" [(ngModel)]="stakeAmount" placeholder="0.0"
            class="w-full bg-dark-900 border border-white/10 text-white rounded-xl py-4 pl-4 pr-20 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all font-mono text-xl">
          <button (click)="setMax()"
            class="absolute right-3 bg-primary-500/20 hover:bg-primary-500/40 text-primary-400 px-3 py-1.5 rounded-lg text-sm font-bold transition-colors">
            MAX
          </button>
        </div>
      </div>
      <button (click)="handleStake()" [disabled]="isPending() || !stakeAmount || stakeAmount <= 0"
        class="w-full bg-gradient-to-r from-primary-600 to-primary-500 hover:from-primary-500 hover:to-primary-400 disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold py-4 rounded-xl shadow-[0_4px_20px_rgba(145,70,255,0.3)] hover:shadow-[0_4px_25px_rgba(145,70,255,0.5)] transition-all transform hover:-translate-y-0.5 relative z-10">
        {{ isPending() ? 'Processing...' : 'Stake Tokens' }}
      </button>
    </div>
    <!-- POSITION SUMMARY CARD -->
    <div (click)="toggleStakesModal()" [class.cursor-pointer]="userStakes().length > 0"
       [class.hover:border-primary-500/30]="userStakes().length > 0"
      class="cardhover-animation glossy-card rounded-3xl p-8 shadow-2xl relative border border-primary-500/10 transition-all bg-dark-800/40">
      <div class="absolute top-0 right-0 p-4">
        <div class="bg-primary-500/10 text-primary-400 p-2 rounded-xl">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
        </div>
      </div>

      <h2 class="text-2xl font-bold mb-6 text-white relative z-10 font-groozila uppercase tracking-wider">Your stakes</h2>

      @if (userStakes().length === 0) {
      <div class="py-4 opacity-50 relative z-10">
        <p class="text-gray-400">No active stakes found.</p>
      </div>
      } @else {
      <div class="space-y-4 relative z-10">
        <div class="flex items-center justify-between">
          <p class="text-gray-400 text-sm font-medium">Total Staked</p>
          <p class="text-xl font-mono text-white">{{ totalStakedAmount | number:'1.0-2' }} <span
              class="text-xs text-gray-500">LOONY</span></p>
        </div>
        <div class="flex items-center justify-between">
          <p class="text-gray-400 text-sm font-medium">Total Pending</p>
          <p class="text-xl font-mono text-primary-400">+{{ totalPendingRewards | number:'1.0-2' }}</p>
        </div>
        <div class="pt-4 border-t border-white/5 flex items-center gap-2 text-primary-400 text-sm font-bold">
          <span>View detailed stakes ({{ userStakes().length }})</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>

<!-- STAKES MODAL -->
@if (showStakesModal()) {
<div class="fixed inset-0 z-[100] flex items-center justify-center px-4">
  <div class="absolute inset-0 bg-black/60 backdrop-blur-md" (click)="toggleStakesModal()"></div>

  <div
    class="glossy-modal w-full max-w-2xl max-h-[85vh] rounded-3xl shadow-2xl overflow-hidden relative z-10 flex flex-col border border-white/10">
    <div class="p-6 border-b border-white/5 flex justify-between items-center">
      <h2 class="text-2xl font-bold text-white font-groozila uppercase tracking-wider">Your Detailed Positions</h2>
      <button (click)="toggleStakesModal()" class="text-gray-400 hover:text-white transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar">
      @for (stake of userStakes(); track stake.index) {
      <div
        class="bg-dark-900/80 rounded-2xl p-6 border border-white/5 space-y-4 hover:border-primary-500/20 transition-all">
        <div class="flex justify-between items-start">
          <div>
            <p class="text-gray-400 text-xs uppercase tracking-wider mb-1 font-bold">Stake #{{ stake.index + 1 }}</p>
            <p class="text-2xl font-mono text-white">{{ stake.amount | number:'1.0-2' }} <span
                class="text-sm text-gray-500">LOONY</span></p>
          </div>
          <div class="flex items-center gap-2 bg-dark-800 px-3 py-1 rounded-full border border-white/5">
            <div class="w-2 h-2 rounded-full" [ngClass]="stake.isMatured ? 'bg-primary-500' : 'bg-yellow-500'"></div>
            <p class="text-white text-xs font-medium">{{ stake.isMatured ? 'Matured' : 'Locked' }}</p>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="bg-dark-800/50 rounded-xl p-3 border border-white/5 text-center">
            <p class="text-gray-400 text-[10px] uppercase tracking-wider mb-1 font-bold">Pending Rewards</p>
            <p class="text-lg font-mono text-primary-400">+{{ stake.pendingRewards | number:'1.0-2' }}</p>
          </div>
          <div class="bg-dark-800/50 rounded-xl p-3 border border-white/5 text-center">
            <p class="text-gray-400 text-[10px] uppercase tracking-wider mb-1 font-bold">Penalty</p>
            <p class="text-lg font-mono text-red-400">{{ stake.isMatured ? '0%' : stake.penaltyPercent + '%' }}</p>
          </div>
        </div>

        @if (!stake.isMatured) {
        <div>
          <div class="flex justify-between text-[10px] text-gray-400 mb-1.5 font-medium">
            <span>Time until Maturity</span>
            <span class="text-primary-400 font-mono text-xs">{{ stake.formattedCountdown }}</span>
          </div>
          <div class="w-full bg-dark-800 rounded-full h-1.5 border border-white/5 overflow-hidden">
            <div class="bg-gradient-to-r from-yellow-500 to-primary-500 h-1.5 rounded-full transition-all duration-1000"
              [style.width]="stake.progressPercent + '%'"></div>
          </div>
        </div>
        }

        @if (!stake.isMatured && stake.penaltyPercent > 0) {
        <div class="bg-red-500/5 border border-red-500/10 rounded-lg p-3">
          <p class="text-red-300/70 text-[10px] leading-relaxed">
            Unstaking now incurs a <b>{{ stake.penaltyPercent }}% penalty</b> ({{ stake.penaltyAmount | number:'1.0-2'
            }} LOONY).
          </p>
        </div>
        }

        <div class="grid grid-cols-2 gap-3 pt-2">
          <button (click)="handleClaim(stake.index)" [disabled]="isPending() || stake.pendingRewards === '0'"
            class="w-full bg-dark-800 hover:bg-primary-500/10 border border-primary-500/20 text-primary-400 py-2.5 rounded-xl text-sm font-bold transition-all disabled:opacity-50">
            Claim Reward
          </button>
          <button (click)="handleUnstake(stake.index)" [disabled]="isPending()"
            [ngClass]="!stake.isMatured ? 'border-red-500/20 text-red-500 hover:bg-red-500/10' : 'border-white/10 text-white hover:bg-white/10'"
            class="w-full bg-dark-800 border py-2.5 rounded-xl text-sm font-bold transition-all disabled:opacity-50">
            Unstake
          </button>
        </div>
      </div>
      }
    </div>

    <div class="p-6 border-t border-white/5 bg-dark-800/50">
      <button (click)="toggleStakesModal()"
        class="w-full bg-dark-700 hover:bg-dark-600 text-white font-bold py-3 rounded-xl transition-all border border-white/10">
        Close List
      </button>
    </div>
  </div>
</div>
}